<template>
  <div>
    <dropdown-menu class="nav navbar-nav px-3 ml-auto" v-show="this.$route.query.slim === undefined">
      <a slot="trigger" class="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
         aria-expanded="false">
        <i class="fa fa-bars user-menu-icon"></i>
      </a>
      <!--<div slot="header">Dropdown Header</div>-->
      <div slot="header">
        <span class="menu-user-info">
          <i class="fa fa-user"></i>&nbsp;&nbsp;<span>{{ userName }}</span>
        </span>
        <span class="text-light menu-versions">
        <span class="version version-be">
          <span class="version-title">Back-end:</span>
          &nbsp;
          <span class="version-value">{{buildVersion}}</span>
        </span>
        <br />
        <span class="version version-fe">
          <span class="version-title">Front-end:</span>
          &nbsp;
          <span class="version-value">{{version}}</span>
        </span>
      </span>
      </div>
      <ul slot="body">
        <li>
            <span class="dropdown-item" @click="pin()">
              <!--<i class="fas fa-sun"></i>-->
              <svg class="icon-menu" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M298 214.3L285.8 96H328c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H56C42.7 0 32 10.7 32 24v48c0 13.3 10.7 24 24 24h42.2L86 214.3C37.5 236.8 0 277.3 0 328c0 13.3 10.7 24 24 24h136v104c0 1.2 .3 2.5 .8 3.6l24 48c2.9 5.9 11.4 5.9 14.3 0l24-48a8 8 0 0 0 .8-3.6V352h136c13.3 0 24-10.7 24-24 0-51.2-38-91.4-86-113.7z"/></svg>
              <span v-if="isPinned">Unpin header</span>
              <span v-if="!isPinned">Pin header</span>
            </span>
        </li>
        <li>
          <a class="dropdown-item"
              target="_blank"
              v-on:click.prevent.stop="EventBus.$emit('openSidebar', '#/settings');"
              href="#/settings">
            <i class="fa fa-gear"></i> Settings
          </a>
        </li>

        <li v-for="(link, linkIndex) in links"
            v-bind:key="linkIndex"
            :class="'menu-sidebar nav-item ' +  link.icon.type"
        >
          <router-link :to="link.to"
                       @click.native="sidebarMenuClick"
                       :class="($route.path == link.to ? ' active ' : ' ') + ' nav-link ' + link.icon.type">
              <span v-if=" link.icon.type == 'bitmap' ">
                <img :src="`/img/${link.icon.value}`"/>
              </span>
            <span v-else-if=" link.icon.type == 'faicon' ">
                <i class="fa" :class="link.icon.value"></i>
              </span>
            <b-icon v-else :icon="link.icon.value"></b-icon>
            <span class="link-text">{{ link.name }}</span>
          </router-link>
        </li>
        <li>
            <span class="dropdown-item" @click="downloadAllTable()">
              <!--<i class="fa fa-download"></i>-->
              <svg class="icon-menu" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"/></svg>
              <span>Export</span>
            </span>
        </li>
        <li>
          <a class="dropdown-item"
             target="_blank"
             v-on:click.prevent.stop="EventBus.$emit('openSidebar', '#/tasks');"
             href="#/tasks">
            <svg class="icon-menu" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M139.6 35.5a12 12 0 0 0 -17 0L58.9 98.8l-22.7-22.1a12 12 0 0 0 -17 0L3.5 92.4a12 12 0 0 0 0 17l47.6 47.4a12.8 12.8 0 0 0 17.6 0l15.6-15.6L156.5 69a12.1 12.1 0 0 0 .1-17zm0 159.2a12 12 0 0 0 -17 0l-63.7 63.7-22.7-22.1a12 12 0 0 0 -17 0L3.5 252a12 12 0 0 0 0 17L51 316.5a12.8 12.8 0 0 0 17.6 0l15.7-15.7 72.2-72.2a12 12 0 0 0 .1-16.9zM64 368c-26.5 0-48.6 21.5-48.6 48S37.5 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0 -16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0 -16-16zm0-320H208a16 16 0 0 0 -16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0 -16-16zm0 160H208a16 16 0 0 0 -16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0 -16-16z"/></svg>
            Tasks
          </a>
        </li>
        <li>
          <router-link class="dropdown-item" :to="'/log/list'">
            <svg class="icon-menu" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 115.28 122.88" style="enable-background:new 0 0 115.28 122.88" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M25.38,57h64.88V37.34H69.59c-2.17,0-5.19-1.17-6.62-2.6c-1.43-1.43-2.3-4.01-2.3-6.17V7.64l0,0H8.15 c-0.18,0-0.32,0.09-0.41,0.18C7.59,7.92,7.55,8.05,7.55,8.24v106.45c0,0.14,0.09,0.32,0.18,0.41c0.09,0.14,0.28,0.18,0.41,0.18 c22.78,0,58.09,0,81.51,0c0.18,0,0.17-0.09,0.27-0.18c0.14-0.09,0.33-0.28,0.33-0.41v-11.16H25.38c-4.14,0-7.56-3.4-7.56-7.56 V64.55C17.82,60.4,21.22,57,25.38,57L25.38,57z M29.49,68.38h7.43v18.15h11.63v5.92H29.49V68.38L29.49,68.38z M49.89,80.43 c0-3.93,1.09-6.99,3.28-9.17c2.19-2.19,5.24-3.28,9.15-3.28c4.01,0,7.09,1.08,9.26,3.22c2.17,2.15,3.25,5.16,3.25,9.04 c0,2.81-0.47,5.11-1.42,6.91c-0.95,1.8-2.32,3.2-4.11,4.2c-1.79,1-4.02,1.5-6.69,1.5c-2.71,0-4.96-0.43-6.74-1.29 c-1.78-0.87-3.22-2.23-4.32-4.11C50.44,85.58,49.89,83.24,49.89,80.43L49.89,80.43z M57.31,80.44c0,2.43,0.45,4.17,1.36,5.23 c0.91,1.06,2.14,1.59,3.7,1.59c1.6,0,2.84-0.52,3.71-1.56c0.88-1.04,1.32-2.9,1.32-5.6c0-2.26-0.46-3.92-1.37-4.96 c-0.92-1.05-2.16-1.57-3.73-1.57c-1.5,0-2.71,0.53-3.62,1.59C57.77,76.24,57.31,77.99,57.31,80.44L57.31,80.44z M90.42,83.74v-5.01 h11.49v10.23c-2.2,1.5-4.15,2.53-5.83,3.07c-1.69,0.54-3.7,0.81-6.02,0.81c-2.86,0-5.19-0.49-6.99-1.46 c-1.8-0.97-3.19-2.42-4.18-4.35c-0.99-1.92-1.48-4.13-1.48-6.63c0-2.63,0.54-4.91,1.62-6.85c1.08-1.94,2.67-3.41,4.76-4.42 c1.63-0.78,3.83-1.17,6.58-1.17c2.66,0,4.64,0.24,5.96,0.72c1.32,0.48,2.41,1.23,3.28,2.24c0.87,1.01,1.52,2.3,1.96,3.85 l-7.16,1.29c-0.3-0.91-0.8-1.61-1.5-2.09c-0.71-0.49-1.6-0.73-2.7-0.73c-1.62,0-2.92,0.57-3.89,1.7c-0.97,1.13-1.45,2.92-1.45,5.37 c0,2.6,0.49,4.46,1.47,5.57c0.97,1.11,2.34,1.68,4.09,1.68c0.83,0,1.62-0.12,2.37-0.36c0.75-0.24,1.61-0.65,2.59-1.22v-2.25H90.42 L90.42,83.74z M97.79,57h9.93c4.16,0,7.56,3.41,7.56,7.56v31.42c0,4.15-3.41,7.56-7.56,7.56h-9.93v13.55c0,1.61-0.65,3.04-1.7,4.1 c-1.06,1.06-2.49,1.7-4.1,1.7c-29.44,0-56.59,0-86.18,0c-1.61,0-3.04-0.64-4.1-1.7c-1.06-1.06-1.7-2.49-1.7-4.1V5.85 c0-1.61,0.65-3.04,1.7-4.1c1.06-1.06,2.53-1.7,4.1-1.7h58.72C64.66,0,64.8,0,64.94,0c0.64,0,1.29,0.28,1.75,0.69h0.09 c0.09,0.05,0.14,0.09,0.23,0.18l29.99,30.36c0.51,0.51,0.88,1.2,0.88,1.98c0,0.23-0.05,0.41-0.09,0.65V57L97.79,57z M67.52,27.97 V8.94l21.43,21.7H70.19c-0.74,0-1.38-0.32-1.89-0.78C67.84,29.4,67.52,28.71,67.52,27.97L67.52,27.97z"/></g></svg>
            Logs
          </router-link>
        </li>
        <li>
          <a class="dropdown-item"
              target="_blank"
              v-on:click.prevent.stop="EventBus.$emit('openSidebar', '#/user/list');"
              href="#/user/list">
            <svg class="icon-menu bi-people-fill b-icon bi" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="people fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><g><path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path><path fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"></path><path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"></path></g></svg>
            Users
          </a>
        </li>
        <li>
          <a class="dropdown-item" href="#" @click="SignOut()">
            <i class="fa fa-lock"></i> Sign out
          </a>
        </li>
        <li>
          <div class="theme-icons-menu">
            <span class="theme-icon-menu theme-icon-dark" @click="setTheme('dark-theme')">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M283.2 512c79 0 151.1-35.9 198.9-94.8 7.1-8.7-.6-21.4-11.6-19.4-124.2 23.7-238.3-71.6-238.3-197 0-72.2 38.7-138.6 101.5-174.4 9.7-5.5 7.3-20.2-3.8-22.2A258.2 258.2 0 0 0 283.2 0c-141.3 0-256 114.5-256 256 0 141.3 114.5 256 256 256z"/></svg>
            </span>
            <span class="theme-icon-menu theme-icon-light" @click="setTheme('light-theme')">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"/></svg>
            </span>
            <span v-show="eventsOffStatus" class="theme-icon-menu" @click="eventsToggle()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M439.4 362.3c-19.3-20.8-55.5-52-55.5-154.3 0-77.7-54.5-139.9-127.9-155.2V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v20.8C118.6 68.1 64.1 130.3 64.1 208c0 102.3-36.2 133.5-55.5 154.3-6 6.5-8.7 14.2-8.6 21.7 .1 16.4 13 32 32.1 32h383.8c19.1 0 32-15.6 32.1-32 .1-7.6-2.6-15.3-8.6-21.7zM67.5 368c21.2-28 44.4-74.3 44.5-159.4 0-.2-.1-.4-.1-.6 0-61.9 50.1-112 112-112s112 50.1 112 112c0 .2-.1 .4-.1 .6 .1 85.1 23.3 131.5 44.5 159.4H67.5zM224 512c35.3 0 64-28.7 64-64H160c0 35.4 28.7 64 64 64z"/></svg>
            </span>
            <span v-show="!eventsOffStatus" class="theme-icon-menu" @click="eventsToggle()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M634 471L36 3.5C29.1-2 19-.9 13.5 6l-10 12.5C-2 25.4-.9 35.5 6 41l598 467.5c6.9 5.5 17 4.4 22.5-2.5l10-12.5c5.5-6.9 4.4-17-2.5-22.5zM163.5 368c16.7-22 34.5-55.8 41.4-110.6l-45.5-35.6c-3.3 90.7-36.5 120.7-54.8 140.4-6 6.5-8.7 14.2-8.6 21.7 .1 16.4 13 32 32.1 32h279.7l-61.4-48H163.5zM320 96c61.9 0 112 50.1 112 112 0 .2-.1 .4-.1 .6 0 16.8 1.2 31.8 2.8 45.7l59.5 46.5c-8.3-22.1-14.3-51.5-14.3-92.9 0-77.7-54.5-139.9-127.9-155.2V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v20.8c-26 5.4-49.5 16.9-69.1 32.7l38.2 29.8C275 103.2 296.7 96 320 96zm0 416c35.3 0 64-28.7 64-64H256c0 35.4 28.7 64 64 64z"/></svg>
            </span>

          </div>
        </li>
      </ul>
      <!--<div slot="footer">Dropdown Footer</div>-->
    </dropdown-menu>
    <header class="app-header navbar" id="header" v-show="this.$route.query.slim === undefined">
      <a class="navbar-brand d-none d-md-inline-flex d-lg-inline-flex d-xl-inline-flex" href="/">
        VM-Manager
      </a>
      <span class="text-light versions">
        <span class="version version-be">
          <span class="version-title">Back-end:</span>
          &nbsp;
          <span class="version-value">{{buildVersion}}</span>
        </span>
        <br />
        <span class="version version-fe">
          <span class="version-title">Front-end:</span>
          &nbsp;
          <span class="version-value">{{version}}</span>
          <span class="version-value"> Memory: {{mem}}</span>
        </span>
      </span>
      <span class="navbar-title text-light">
        <span id="navbar-title-tasks" class="navbar-title-tasks">
          <span class="navbar-title-tasks-action" @click="tasksShow">
            <span v-show="eventsOffStatus" class="theme-icon-menu" @click="eventsToggle()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M634 471L36 3.5C29.1-2 19-.9 13.5 6l-10 12.5C-2 25.4-.9 35.5 6 41l598 467.5c6.9 5.5 17 4.4 22.5-2.5l10-12.5c5.5-6.9 4.4-17-2.5-22.5zM163.5 368c16.7-22 34.5-55.8 41.4-110.6l-45.5-35.6c-3.3 90.7-36.5 120.7-54.8 140.4-6 6.5-8.7 14.2-8.6 21.7 .1 16.4 13 32 32.1 32h279.7l-61.4-48H163.5zM320 96c61.9 0 112 50.1 112 112 0 .2-.1 .4-.1 .6 0 16.8 1.2 31.8 2.8 45.7l59.5 46.5c-8.3-22.1-14.3-51.5-14.3-92.9 0-77.7-54.5-139.9-127.9-155.2V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v20.8c-26 5.4-49.5 16.9-69.1 32.7l38.2 29.8C275 103.2 296.7 96 320 96zm0 416c35.3 0 64-28.7 64-64H256c0 35.4 28.7 64 64 64z"/></svg>
            </span>
            <span class="navbar-title-tasks-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"/></svg>
            </span>
            <span v-show="taskCount" class="navbar-title-tasks-count">{{ taskCountValue }}</span>
            <span class="navbar-title-tasks-icon navbar-title-tasks-icon-rotate">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M0 384.7V127.3c0-17.8 21.5-26.7 34.1-14.1l128.7 128.7c7.8 7.8 7.8 20.5 0 28.3L34.1 398.8C21.5 411.4 0 402.5 0 384.7z"/></svg>
            </span>
          </span>
          <div id="navbar-title-tasks-content" class="navbar-title-tasks-content">
            <div class="navbar-title-tasks-content-header">
              <span class="navbar-title-tasks-content-header-controls">
                <span class="navbar-title-tasks-content-header-control-clear tasks-btn" @click="tasksClear">
                  Clear
                </span>
                <span class="navbar-title-tasks-content-header-control-collapse tasks-btn" @click="hideAllTasks">
                  Collapse all
                </span>
                <span class="navbar-title-tasks-content-header-control-text">
                  <span class="navbar-title-tasks-content-header-control-show-last tasks-btn" @click="showLastTasks">
                    Show last tasks by {{lastTasksMin}} min
                  </span>
                </span>
                <span class="navbar-title-tasks-content-header-control-text">
                  <span class="navbar-title-tasks-content-header-control-show-last tasks-btn" @click="showLastTasksBy(20)">
                    Show last 20 tasks today
                  </span>
                </span>
                <span v-show="taskSkippedCount" class="navbar-title-tasks-content-header-control-text">
                  <span class="navbar-title-tasks-content-header-control-show-skipped tasks-btn" @click="showLastTasksBy(taskSkippedCount)">
                    Show {{taskSkippedCount}} skipped tasks
                  </span>
                </span>
              </span>
              <span class="navbar-title-tasks-content-header-expand">

              </span>
            </div>
            <div class="navbar-title-tasks-content-container">
              <div class="navbar-title-tasks-content-item" v-for="[taskIndex, taskItem] of taskList" v-bind:key="taskIndex">
                <a :href="`/#/task/item?id=${taskIndex}`">
                  <span class="navbar-title-tasks-icon">
                    <svg v-show="taskItem.Status < 3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M360 0H24C10.7 0 0 10.7 0 24v16c0 13.3 10.7 24 24 24 0 91 51 167.7 120.8 192C75 280.3 24 357 24 448c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24 0-91-51-167.7-120.8-192C309 231.7 360 155 360 64c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24zm-75.1 384H99.1c17.1-46.8 52.1-80 92.9-80 40.8 0 75.9 33.2 92.9 80zm0-256H99.1C92 108.5 88 86.7 88 64h208c0 22.8-4 44.6-11.1 64z"/></svg>
                    <svg v-show="taskItem.Status >= 3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"/></svg>
                  </span>
                </a>
                <span class="navbar-title-tasks-content-item-time">[{{ taskItem.FrontEventTime }}] </span>
                <span class="navbar-title-tasks-content-item-name" :data="taskIndex">
                  <span class="navbar-title-tasks-content-item-name-text" @click="e => e.target.parentNode.classList.toggle('closed')">
                    {{ taskItem.Name }}
                  </span>
                  <span class="navbar-title-tasks-icon" @click="e => e.target.parentNode.classList.toggle('closed')">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M0 384.7V127.3c0-17.8 21.5-26.7 34.1-14.1l128.7 128.7c7.8 7.8 7.8 20.5 0 28.3L34.1 398.8C21.5 411.4 0 402.5 0 384.7z"/></svg>
                  </span>
                </span>
                <span class="navbar-title-tasks-content-item-text"><pre>{{ taskItem.Result }}</pre></span>
              </div>
            </div>
          </div>
        </span>
        <span class="navbar-title-text">{{ title }}</span>
        <span class="navbar-title-text">{{ total }}</span>
        <span class="navbar-title-text">{{ filter }}</span>
      </span>
    </header>

    <div class="sidebar" id="left-sidebar" v-show="this.$route.query.slim === undefined">
      <nav class="sidebar-nav">
        <ul class="nav">
          <li v-for="(link, linkIndex) in links"
              v-bind:key="linkIndex"
              :class="'nav-item ' +  link.icon.type"
          >
            <router-link :to="link.to"
                         @click.native="sidebarMenuClick"
                         :class="($route.path == link.to ? ' active ' : ' ') + ' nav-link ' + link.icon.type">
              <span v-if=" link.icon.type == 'bitmap' ">
                <img :src="`/img/${link.icon.value}`"/>
              </span>
              <span v-else-if=" link.icon.type == 'faicon' ">
                <i class="fa" :class="link.icon.value"></i>
              </span>
              <b-icon v-else :icon="link.icon.value"></b-icon>
              <span class="link-text">{{ link.name }}</span>
            </router-link>
          </li>
        </ul>
      </nav>
      <button class="sidebar-minimizer brand-minimizer" type="button"></button>
    </div>
    <div id="offline-status" class="offline-status-hidden"><span class="text">ERROR: EVENTS OFFLINE</span><span @click="Vue.prototype.$eventsHub();" class="reconnect-btn"> reconnect</span><span id="reconnect-timer"></span></div>
  </div>
</template>

<script>
import axios from "axios";
import DropdownMenu from 'v-dropdown-menu'
import 'v-dropdown-menu/dist/v-dropdown-menu.css'
import Vue from "vue"; // Base style, required.
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";
import {TokenMixin} from '@/assets/js/mixins/token-mixin';
import {EventBus} from "@/eventBus";
import {NotifyMixin} from '@/assets/js/mixins/notify-mixin';
import _ from "lodash";

export default {
  name: 'Header',
  mixins: [
    TokenMixin,
    ErrorsMixin,
    NotifyMixin,
  ],
  computed: {
    EventBus() {
      return EventBus
    },
    Vue() {
      return Vue
    },
    taskCountValue() {
      return (this.taskCount > 0)?` ${this.taskCount}${this.tasksNew} `:"";
    },
    skippedPeriod() {
      if (this.hiddenTimeOffset <= 60) {
        return this.hiddenTimeOffset + ' sec';
      }
      return Math.ceil(this.hiddenTimeOffset/60) + ' min';
    }
  },
  components: {
    DropdownMenu
  },
  props: ['title', 'filter', 'total'],
  data() {
    return {
      sidebarMini: true,
      error: '',
      version: process.env.VUE_APP_VERSION,
      apiConfig: '/api/config/menu/left',
      apiSignOut: '/api/auth/sign-out/',
      apiUserInfo: '/api/user/',
      apiBuildInfo: '/api/version/',
      apiExportAll: '/api/manager/export/exel',
      apiTaskList: 'api/task/list',
      loadFormat: 'xlsx',
      login: '/login',
      themes:[
        {'text':'Dark theme','value':'dark-theme'},
        {'text':'Light theme','value':'light-theme'},
      ],
      links: [
        {name: 'Home', to: '/', icon: {type: 'vector', value: 'house-fill'}},
        {name: 'Datacenters', to: '/dc/list', icon: {type: 'bitmap', value: 'dc.png'}},
        {name: 'IPs', to: '/ip/list', icon: {type: 'bitmap', value: 'ip.png'}},
        {name: 'Servers', to: '/server/list', icon: {type: 'bitmap', value: 'esxi.png'}},
        {name: 'VMs', to: '/vm/list', icon: {type: 'bitmap', value: 'vm.png'}},
        //{name: 'Users', to: '/user/list', icon: {type: 'vector', value: 'people-fill'}},
        //{name: 'Logs', to: '/log/list', icon: {type: 'bitmap', value: 'log.png'}},
      ],
      userMenuShow: false,
      isPinned: false,
      userName: 'User@user',
      buildVersion: null,
      taskCount: 0,
      taskSkippedCount: 0,
      tasksNew: "",
      taskList: new Map(),
      taskListTimes: new Map(),
      mem: '',
      lastTasksMin: 5,
      serverTimeOffset: 0,
      hiddenTimeOffset: 0,
      eventsOffStatus: false,
    }
  },
  methods: {
    SignOut() {
      localStorage.removeItem('token');
      axios.post(this.apiSignOut, {}, this.authRespConf());
      this.$router.push({path: this.login});
    },
    getBuildVersion() {
      axios.get(this.apiBuildInfo, this.authRespConf())
          .catch((err) => {
            //TODO: create errors stack
            console.log(err.response.status);
          })
          .then(res => {
            this.buildVersion = res.data
          });
    },
    LoadConfig() {
      this.error = '';
      axios.get(this.apiUserInfo,
          this.authRespConf())
          .catch((err) => {
            //TODO: create errors stack
            console.log(err.response.status);
          })
          .then(res => {
            if (res !== null && res !== undefined) {
              if (res.data !== null && res.data !== undefined) {
                this.userName = res.data.data.Email;
                localStorage.setItem('user', JSON.stringify(res.data.data));
              }
            }
          });
    },
    setTheme(theme) {
      for (let index in this.themes) {
        document.getElementById('app').classList.remove(this.themes[index]['value']);
      }
      document.getElementById('app').classList.add(theme);
      localStorage.setItem('theme', theme);
      location.reload();
    },
    eventsToggle(){
      this.eventsOffStatus = !this.eventsOffStatus;
      EventBus.$emit('events-off-status', this.eventsOffStatus);
    },
    eventsCheckStatus(){
      let savedStatus = localStorage.getItem('eventsOffStatus');
      this.eventsOffStatus = (savedStatus === true || savedStatus === "true")?savedStatus:false;
      EventBus.$emit('events-off-status', this.eventsOffStatus);
    },
    pin() {
      if (document.getElementById('app').classList.contains('pin-head')) {
        document.getElementById('app').classList.remove('pin-head');
        document.body.classList.remove('pin-head');
        localStorage.removeItem('pin-head');
      } else {
        document.getElementById('app').classList.add('pin-head');
        document.body.classList.add('pin-head');
        localStorage.setItem('pin-head', "pin-head");
      }
      this.isPinned = (localStorage.getItem('pin-head') != null);
    },
    downloadAllTable(showLoader = true) {
      let loader
      if (showLoader) {
        loader = this.$loading.show();
      }
      this.error = '';
      axios.post(this.apiExportAll,
          {},
          {headers: this.authHeader(), responseType: 'blob'})
          .catch((err) => {
            if (showLoader) {
              loader.hide();
            }
            this.errorHandle(err, true, true);
          })
          .then(res => {
            if (showLoader) {
              loader.hide();
            }
            const blob = new Blob([res.data])
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'Export(' + (new Date()).toLocaleString() + ' - ' + document.location.host + ').' + this.loadFormat
            link.click()
            URL.revokeObjectURL(link.href)
          })
    },
    sidebarMenuClick() {
      EventBus.$emit('sidebar-menu-click', "");
      console.log('sidebarMenuClick');
    },
    tasksShow() {
      this.tasksNew = document.getElementById('navbar-title-tasks').classList.contains('active')?this.tasksNew:"";
      //console.log('tasksShow');
      document.getElementById('navbar-title-tasks').classList.toggle('active');
    },
    tasksClear() {
      console.log('tasksShow');
      this.taskList.clear();
      this.taskListTimes.clear();
      this.taskCount = this.taskList.size;
    },
    hideAllTasks() {
      for (let t of document.getElementsByClassName('navbar-title-tasks-content-item-name')) {
        t.classList.add('closed');
      }
    },
    showSkippedTasks() {
      this.loadTasksBy(this.hiddenTimeOffset);
    },
    showLastTasks() {
      this.loadTasksBy(this.lastTasksMin * 60);
    },
    showLastTasksBy(count) {
      this.loadTasksBy(1440 * 60, count);
    },
    loadTasksBy(offset, limit = 0) {
      this.error = '';
      if (this.serverTimeOffset === 0) {
        this.serverTimeOffset = (new Date()).getTimezoneOffset() * (-60); //local time zone offset
      }
      const offsetSeconds = this.serverTimeOffset - offset
      const now = new Date();
      now.setSeconds(now.getSeconds() + offsetSeconds);
      const isoString = now.toISOString().slice(0, 19);
      let data = [{"Condition": ">=", "Data": {"StartedAt": isoString}}]
      let url = this.apiTaskList
      if (limit !== 0) {
        url += "?limit=" + limit;
      }
      axios.post(url, data, this.authRespConf())
          .then(res => {
            if (res !== null && res !== undefined) {
              if (res.data.message !== null && res.data.message !== undefined) {
                this.notifyData = res.data.message;
                this.textareaData = res.data.message;
                console.log(res.data.message);
                this.showNotifyData();
              } else {
                if (res.data.data.length === 0) {
                  this.NotifyWarning(`Task list`, "Not found with current filters");
                  return;
                }
                for (let i in res.data.data) {
                  this.tasksUpdateHandler(res.data.data[i]);
                }
              }
            }
          })
          .catch((err) => {
            this.errorHandle(err, true, true);
          });
    },
    tasksUpdateHandler(item) {
      console.log('tasksUpdateHandler', item);
      if (_.isEmpty(item)) {
        return;
      }
      if (item.Id == null) {
        return;
      }
      this.tasksNew = "*"
      if (!this.taskList.has(item.Id)) {
        item.FrontEventTime = (new Date().toLocaleTimeString());
      } else {
        item.FrontEventTime = this.taskList.get(item.Id).FrontEventTime;
      }
      this.taskList.set(item.Id, item);
      this.taskCount = this.taskList.size;
    },
    calcMem() {
      if (window.performance != null) {
        if (window.performance.memory != null) {
          let size = window.performance.memory.usedJSHeapSize;
          let label = "bytes";
          if (size > 1024) {
            label = "Kb";
            size = Math.round(size / 1024);
          }
          if (size > 1024) {
            label = "Mb";
            size = Math.round(size / 1024)
          }
          this.mem = size + " " + label;
        }
      }
    },
    visibilitychange(data) {
      console.log('visibilitychange0', data);
      if (data !== null && data !== undefined) {
        console.log('visibilitychange1', data);
        if (data.tasks !== null && data.tasks !== undefined) {
          console.log('visibilitychange2', data);
          this.taskSkippedCount = data.tasks;
          this.hiddenTimeOffset = data.seconds + 60;
        }
      }
      console.log('visibilitychange3', this.taskSkippedCount, this.hiddenTimeOffset );
    },
  },
  created: function () {
    this.eventsCheckStatus();
    this.isPinned = (localStorage.getItem('pin-head') != null);
    this.LoadConfig();
    this.getBuildVersion();
    EventBus.$on("task-add", this.tasksUpdateHandler);
    EventBus.$on("task-update", this.tasksUpdateHandler);
    EventBus.$on("visibilitychange", this.visibilitychange);
    window.setInterval(this.calcMem, 5000);
  },
  beforeDestroy() {
    EventBus.$off("task-add", this.tasksUpdateHandler);
    EventBus.$off("task-update", this.tasksUpdateHandler);
    EventBus.$off("visibilitychange", this.visibilitychange);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.header-button {
  position: absolute;
  top: 10px;
  left: 15px;
  cursor: pointer;
}

.header-menu {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  left: 0px;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
  border: 2px solid;
}

.header-user {
  float: right;
  margin: 10px 20px 0 0;
  padding: 2px;
  font-weight: 500;
}

.header-user:hover {
  color: #666;
  cursor: pointer;
}

.header-user {
  float: right;
  margin: 10px 20px 0 0;
}

.header-menu-close {
  float: right;
  cursor: pointer;
  padding: 0 4px 0 4px;
}

.header-menu-close:hover {
  background: #000;
  color: #fff;
  border-radius: 50%;
}

.header-menu-list {
  padding-top: 15px;
  padding: 0 10px 10px 10px;
}

.header-menu-list a {
  font-size: 23px;
  color: #202020;
}

.header-top {
  height: 60px;
  z-index: 999;
}

.header-top h1 {
  font-size: 1.75rem;
  margin-left: 80px;
  display: inline;
  line-height: 50px;
}

.header-user-menu-links a:hover {
  background: #212529;
  color: #fff;
  text-decoration: none;
}

.header-user-menu-links a {
  color: #000;
  display: block;
  padding: 2px 11px;
}

.sidebar-left {
  background-color: #1d212a;
}

aside.sidebar-mini {
  width: 50px;
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  -ms-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.sidebar {
  display: block;
}

.sidebar {
  position: fixed;
  top: 0;
  min-height: 100%;
  width: 240px;
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  -ms-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section, summary {
  display: block;
}

aside.sidebar-mini .sidebar-header, aside.sidebar-mini .sidebar-profile, aside.sidebar-mini .sidebar-summary {
  display: none;
}

.sidebar-header {
  color: #6F737E;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  padding: 10px 10px 5px;
  text-transform: uppercase;
}

h5, .h5 {
  font-size: 0.813em;
}

h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
  font-family: "Montserrat", sans-serif;
  color: #424856;
  margin: 0;
}

aside.sidebar-mini .nav-pills {
  margin-left: 5px;
  margin-right: 5px;
}

.sidebar .nav-pills {
  margin-left: 10px;
  margin-right: 10px;
}

.nav {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-stacked > li {
  float: none;
}

.nav-pills > li {
  float: left;
}

.nav > li {
  position: relative;
  display: block;
}

aside.sidebar-mini .nav > li > a {
  padding: 10px 9px;
  white-space: nowrap;
  overflow: hidden;
}

.sidebar .nav-pills > li > a {
  padding: 9px 10px;
  font-size: 0.875em;
}

.sidebar li.nav-item.vector {
  font-size: 21px;
}

.sidebar .nav a {
  text-decoration: none;
  font-weight: 600;
}

.sidebar .nav a {
  padding: 0.75rem 0.7rem;
}

.sidebar .nav a span {
  margin-right: 10px;
}

.sidebar .nav a span img, .menu-sidebar img {
  width: 22px;
}
.menu-sidebar img, .menu-sidebar svg {
  margin: 0 14px 0 10px;
}

.sidebar .nav a svg {

}

.sidebar .nav a .link-text {
  font-size: 12px;
  display: inline-block;
  margin-left: 5px;
}

.nav-pills > li > a {
  border-radius: 4px;
}

.nav > li > a {
  position: relative;
  display: block;
  padding: 10px 15px;
  width: 100%;
}

.sidebar-left a {
  /*color: #B3B8C3;*/
  color: #fff;
}

aside.sidebar-mini .nav-pills > li.nav-dropdown-open, aside.sidebar-mini .nav-pills > li:hover {
  width: 235px;
}

aside.sidebar-mini .nav > li.nav-dropdown-open, aside.sidebar-mini .nav > li:hover {
  width: 240px;
  z-index: 10;
}

.nav-stacked > li + li {
  margin-top: 2px;
  margin-left: 0;
}

.nav-pills > li + li {
  margin-left: 2px;
}

.nav-stacked > li {
  float: none;
}

.nav-pills > li {
  float: left;
}

.nav > li {
  position: relative;
  display: contents;
}

aside.sidebar-mini .nav > li {
  display: block;
}

aside.sidebar-mini .nav > li.nav-dropdown-open > a, aside.sidebar-mini .nav > li:hover > a {
  color: #1d2939;
  background-color: #fff;
}

.sidebar-left .nav > li.open > a, .sidebar-left .nav > li > a:hover {
  color: #1d2939;
  background-color: #ffffff;
}

aside.sidebar-mini .nav > li.nav-dropdown-open a, aside.sidebar-mini .nav > li:hover a {
  display: block;
  overflow: visible;
}

.sidebar .nav-pills > li > a {
  padding: 9px 10px;
  font-size: 0.875em;
}

aside.sidebar-mini .nav-pills > li > a > svg {
  margin-right: 15px;
  width: 23px;
}

aside.sidebar-mini .nav > li.nav-dropdown-open a, aside.sidebar-mini .nav > li:hover a {
  /*display: block;*/
  overflow: visible;
}

aside.sidebar-mini .nav > li > a {
  padding: 10px 9px;
  white-space: nowrap;
  overflow: hidden;
}

.sidebar .nav-pills > li > a {
  padding: 9px 10px;
  font-size: 0.875em;
}

.nav > li > a:hover, .nav > li > a:focus {
  text-decoration: none;
  background-color: #eee;
}

.sidebar-left a:focus, .sidebar-left a:hover {
  color: #fff;
  background-color: transparent;
}

.sidebar .nav a {
  text-decoration: none;
  font-weight: 600;
}

aside.sidebar-mini .nav > li > a {
  display: flex;
}

.nav > li:after {
  content: '';
  width: 100%;
  order: 0;
}

aside.sidebar:hover {
  overflow: visible;
}

aside.sidebar {
  overflow: hidden;
}

.header-top h1 {
  font-size: 1.75rem;
  margin-left: 80px;
  display: inline;
  line-height: 50px;
}

/* pin-head */
.pin-head .card-header {
  top: 0;
  z-index: 9999;
  right: 0px;
  padding: 4px;
  border-bottom: none;
  background: none;
  position: fixed;
}

@media (max-width: 1700px) {
  .pin-head .card-header {
    margin-left: 36px;
  }
}

.card-header {
  background-color: #fff;
  border-bottom: 1px solid #eff2f7;
  padding: 1rem 1rem;
}

.pin-head .header-fixed .app-header {
  position: fixed;
}

.pin-head .header-fixed .app-header {
  position: fixed;
}

.pin-head .card-body {
  margin-top: 40px;
}

/* short username link */
.navbar-nav .nav-link {
  color: #fff;
  max-width: 200px;
  max-height: 48px;
}
.theme-icon-menu:hover {
   background-color: #464646;
   color: white;
 }
.theme-icon-menu {
  color: #464646;
  font-weight: bold;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 17px;
}
.theme-icons-menu {
  text-align: center;
  width: 100%;
}
.icon-menu {
  max-width: 10px;
  margin: 0 14px 0 -5px;
}
.theme-icon-light, .dark-theme .theme-icon-dark {
  display: none;
}
.dark-theme .theme-icon-light {
  display: inline;
}
.pin-head #header {
  position: fixed;
}
.pin-head .main {
  padding-top: 50px;
}
.dropdown-item {
  cursor: pointer;
}
body.pin-head .b-toaster, .pin-head .item-body {
  margin-top: 50px;
}
i.fa.fa-bars.user-menu-icon {
  font-size: 22px;
}
body .v-dropdown-menu--direction-left .v-dropdown-menu__container {
  left: 0 !important;
  min-width: max-content !important;
}
body.dark-theme .v-dropdown-menu--direction-left .v-dropdown-menu__container,
body.dark-theme .v-dropdown-menu--direction-left .v-dropdown-menu__container a,
body.dark-theme .v-dropdown-menu--direction-left .v-dropdown-menu__container i,
body.dark-theme .v-dropdown-menu--direction-left .v-dropdown-menu__container span,
body.dark-theme .v-dropdown-menu--direction-left .v-dropdown-menu__container svg {
  color: #fff;
  fill: #fff;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: #181b1e;
  text-decoration: none;
  background-color: #339ffd;
}

body.dark-theme .v-dropdown-menu--direction-left .v-dropdown-menu__container {
  background: #000;
  /* color: #fff; */
  /* border: 1px #fff solid; */
}
.v-dropdown-menu__header {
  text-align: center;
  padding: 5px;
}
#header.app-header {
  padding-left: 50px;
}
body .v-dropdown-menu {
  position: fixed;
  z-index: 9999;
}
.app-header .navbar-brand {
  position: absolute;
}
.versions {
  margin-left: 134px;
  position: absolute;
}
.menu-versions, .menu-sidebar {
  display: none;
}
#navbar-title-tasks svg {
  height: 18px;
  vertical-align: middle;
  margin: 0px 5px 3px 0px;
}

#navbar-title-tasks .navbar-title-tasks-action svg {
  fill: #fff;
  transition: .5s ease-in-out;
}
#navbar-title-tasks.active .navbar-title-tasks-icon-rotate svg {
  rotate: 90deg;
}
#navbar-title-tasks {
  padding: 8px;
}
#navbar-title-tasks svg:hover {
  fill: #8378f5;
  cursor: pointer;
}
.navbar-title-tasks-content {
  position: absolute;
  display: none;
  background: white;
  color: #333;
  border: 1px solid #222;
  padding: 10px;
  width: 50%;
  left: 25%;
  max-height: 90vh;
  overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: #1c1c1c #d9d9d9;
  scrollbar-gutter: stable;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}
body.dark-theme .navbar-title-tasks-content {
  background: black;
  border: 1px solid #979595;
  box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
  scrollbar-color: #d9d9d9 #1c1c1c;
  color: #979595;
}
#navbar-title-tasks .navbar-title-tasks-content-container svg {
  fill: black;
}
body.dark-theme #navbar-title-tasks .navbar-title-tasks-content-container svg {
  fill: #d9d9d9;
}

#navbar-title-tasks.active .navbar-title-tasks-content {
  display: block;
}
.navbar-title-tasks-content-item-text {
  display: block;
}
.navbar-title-tasks-content-item-name.closed+.navbar-title-tasks-content-item-text {
  display: none;
}
.navbar-title-tasks-content-item-name svg {
  rotate: 90deg;
}
.navbar-title-tasks-content-item-name.closed svg {
  rotate: 0deg;
}
.navbar-title-tasks-content-item-name{
  cursor: pointer;
}
.navbar-title-tasks-content-header {
  padding-bottom: 2px;
  border-bottom: 1px solid #000;
  margin-bottom: 5px;
}
.navbar-title-tasks-content-header-controls .tasks-btn {
  display: inline-block;
  cursor: pointer;
  border: 1px solid #f1f1f1;
  padding: 1px 7px;
  margin: 2px;
}
.navbar-title-tasks-content-header-controls .tasks-btn:hover {
  background-color: #ab7103;
  color: #000000;
}
body.dark-theme .navbar-title-tasks-content-item-time {
  color: #ab7103;
}
body.dark-theme .navbar-title-tasks-content-header {
  font-size: 85%;
}
span.theme-icon-menu svg {
  height: 18px;
  vertical-align: middle;
  margin: 0 5px 3px 0;
}
</style>
